import {isProduction} from "./isProduction";

const PRODUCTION_MODE_FAST_TEXT = false // false
const PRODUCTION_WIN_FAST = false // false
const PRODUCTION_LOW_ALLIES_COUNT = false; // false
const PRODUCTION_SCROLL = false; // false
const PRODUCTION_DAMAGE_ENABLED = true // true
const PRODUCTION_MOVEMENT_ENABLED = true // true
const PRODUCTION_UNIT_SIZE = 16; // 16
const PRODUCTION_MY_UNITS_POSITION = 32 // 32


const pick = (value, productionValue) => isProduction ? productionValue : value


export const SIDES_ME = "red"
export const SIDES_ENEMY = "green"

export const UNIT_SIZE                = pick(PRODUCTION_UNIT_SIZE, PRODUCTION_UNIT_SIZE); // 16
export const MY_UNITS_POSITION        = pick(10, PRODUCTION_MY_UNITS_POSITION) // 32

export const DEBUG_DAMAGE_ENABLED     = pick(PRODUCTION_DAMAGE_ENABLED, PRODUCTION_DAMAGE_ENABLED) // true
export const DEBUG_MOVEMENT_ENABLED   = pick(PRODUCTION_MOVEMENT_ENABLED, PRODUCTION_MOVEMENT_ENABLED) // true

export const DEBUG_MODE_FAST_TEXT     = pick(PRODUCTION_MODE_FAST_TEXT, PRODUCTION_MODE_FAST_TEXT) // false
export const DEBUG_WIN_FAST           = pick(PRODUCTION_WIN_FAST, PRODUCTION_WIN_FAST) // false
export const DEBUG_LOW_ALLIES_COUNT   = pick(true, PRODUCTION_LOW_ALLIES_COUNT); // false

export const DEBUG_SCROLL             = pick(PRODUCTION_SCROLL, PRODUCTION_SCROLL); // false


export const MODE_SCRIPT = "MODE_SCRIPT"
export const MODE_BATTLE = "MODE_BATTLE"
export const MODE_BATTLE_END = "MODE_BATTLE_END"

export const MODE_BASE = pick(MODE_BATTLE, MODE_SCRIPT) // MODE_SCRIPT

/// -----
export const step = 0.065; //0.045
export const combatWidthX = Math.floor(1024 / UNIT_SIZE)
export const combatWidthY = Math.floor(768 / UNIT_SIZE)

export const myWidth = 12

export const myTroopsCount = DEBUG_LOW_ALLIES_COUNT ? 2 : 100; // normal unit is 100


export const PERIOD_LENGTH = 50 // ms
export const TROOP_TYPE_INFANTRY = "ქვეითები" // 1;
export const TROOP_TYPE_CAVALRY = "კავალერია" //2;
export const TROOP_TYPE_ARCHERS = "ისრები" //3;
export const TROOP_TYPE_ARTILLERY = "არტილერია" //4;